import { Route } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivateChild: [autoLoginPartialRoutesGuard], // checks globally if the user has an active session with HelloID
    children: [
      { path: '', redirectTo: 'aanvragen', pathMatch: 'full' },
      { path: 'aanvragen', loadChildren: () => import('@pf/ocs/requests').then(m => m.RequestRoutes) },
      { path: 'authorize', redirectTo: 'aanvragen' }, // This is used as the "allowed" redirect url for the oidc client
      { path: 'forbidden', loadChildren: () => import('@pf/shared/features/auth').then(m => m.AuthenticationRoutes) },
    ],
  },
  { path: 'unauthorized', loadChildren: () => import('@pf/shared/features/auth').then(m => m.AuthenticationRoutes) },
];
